import { mapExchange } from 'urql'

// Server may return either "Authentication required" or "Not authenticated" from
// different code paths; both mean the session has expired and we should redirect
// to login instead of leaving the user staring at a spinner.
export const AUTH_ERROR_MESSAGES = new Set(['Authentication required', 'Not authenticated'])

// Shared with MessageStore.sendEmail, whose XHR bypasses this exchange.
export function redirectToLogin() {
  if (window.location.pathname.startsWith('/login')) return
  const returnTo = encodeURIComponent(window.location.pathname + window.location.search)
  window.location.href = `/login?redirectTo=${returnTo}`
}

export const authErrorExchange = mapExchange({
  onResult(result) {
    if (result.error?.graphQLErrors.some((e) => AUTH_ERROR_MESSAGES.has(e.message))) redirectToLogin()
  },
})
